import apiFetch from '../../apiFetch'

export default function (paperworkId, token) {
  return apiFetch({
    endPoint: `Dossier/Paperwork/${paperworkId}/OrderStatus`,
    method: 'GET',
    token: token
  })
}
